import React from 'react';

export default function NoData(props: { height: number; hint: string }) {
  return (
    <div
      style={{
        height: props.height,
        textAlign: 'center',
        color: 'grey',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column'
      }}
    >
      <h4>No data</h4>
      <h6>{props.hint}</h6>
    </div>
  );
}
